import * as React from 'react'
import Svg, { G, Path, Defs, ClipPath, Rect } from 'react-native-svg'
export const EyeIcon = () => (
  <Svg width={16} height={16} viewBox='0 0 16 16' fill='none'>
    <G clipPath='url(#clip0_7191_7202)'>
      <Path
        d='M0.666016 7.99984C0.666016 7.99984 3.33268 2.6665 7.99935 2.6665C12.666 2.6665 15.3327 7.99984 15.3327 7.99984C15.3327 7.99984 12.666 13.3332 7.99935 13.3332C3.33268 13.3332 0.666016 7.99984 0.666016 7.99984Z'
        stroke='#425563'
        strokeWidth={1.6}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M7.99935 9.99984C9.10392 9.99984 9.99935 9.10441 9.99935 7.99984C9.99935 6.89527 9.10392 5.99984 7.99935 5.99984C6.89478 5.99984 5.99935 6.89527 5.99935 7.99984C5.99935 9.10441 6.89478 9.99984 7.99935 9.99984Z'
        stroke='#425563'
        strokeWidth={1.6}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </G>
    <Defs>
      <ClipPath id='clip0_7191_7202'>
        <Rect width={16} height={16} fill='white' />
      </ClipPath>
    </Defs>
  </Svg>
)
